<template><div></div></template>

<script>
import { openDefaultEditor } from "@pqina/pintura";

export default {
  name: "NzCropperPintura",

  props: {
    src: String,
    aspect: Number,
  },

  emits: ["close", "cropped"],

  mounted() {
    this.launch();
  },

  methods: {
    async launch() {
      const parent = document.querySelector(".nz-modal-body") || document.body;

      const editor = openDefaultEditor(
        {
          src: this.src,
          imageCropAspectRatio: this.aspect || null,
          imageWriter: {
            mimeType: "image/jpeg",
            quality: 0.92,
          },
        },
        parent
      );

      editor.on("process", ({ dest, imageState }) => {
        if (imageState?.canvas) {
          imageState.canvas.toBlob(blob => {
            this.$emit("cropped", blob);
          }, "image/jpeg", 0.92);
        } else {
          this.$emit("cropped", dest);
        }
        editor.close();
        this.$emit("close");
      });

      editor.on("close", () => this.$emit("close"));
    },
  },
};
</script>
